import { render, staticRenderFns } from "./PortoDetalhes.vue?vue&type=template&id=da9bd4a6"
import script from "./PortoDetalhes.vue?vue&type=script&lang=js"
export * from "./PortoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports